<template>
    <div class="bk-frame">
        <div class="bk-widget bk-loading" :class="[`bk-widget-${random}`]">
          <div class="bk-loader">
            <div class="bk-loader__spinner">
              <div class="bk-loader__dot">&bull;</div>
              <div class="bk-loader__dot">&bull;</div>
              <div class="bk-loader__dot">&bull;</div>
              <div class="bk-loader__dot">&bull;</div>
              <div class="bk-loader__dot">&bull;</div>
              <div class="bk-loader__dot">&bull;</div>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import bkWidget from "../services/bk.widget.service";
import { EventBus } from "../../_common/event-bus";

export default {
    name: "bk-frame",
    props: {
        routePrefix: {
            type: String,
            default: "",
            required: false
        },
        theme: {
            type: String,
            default: "",
            required: false
        },
        component: {
            type: String,
            default: "",
            required: false
        },
        outcomes: {
            type: Boolean,
            default: true,
            required: false
        },
        hidenav: {
            type: Boolean,
            default: false,
            required: false
        },
        settings: {
            type: Object,
            default: () => {},
            required: false,
        },
        onInit: {
            type: Function,
            required: false
        },
        onShowed: {
            type: Function,
            required: false
        },
        onOrderDisplay: {
            type: Function,
            required: false
        },
        onOrderEnabled: {
            type: Function,
            required: false
        },
        onOrdered: {
            type: Function,
            required: false
        },
        onDestroying: {
            type: Function,
            required: false
        }
    },
    data() {
        return {
            random: this.getRandom(7),
            instance: null,
            watchIsLoggedIn: false,
            destroying: false
        };
    },
    computed: {
        isHome() {
            return !this.route || this.route === "home";
        },
        route() {
            return this.$route.fullPath;
        },
        lang() {
            return Vue.state.lang.currentLang;
        },
        client() {
            return Vue.state.client.get();
        },
        isLoggedIn() {
            return Vue.state.player.isLoggedIn();
        }
    },
    watch: {
        route: function() {
            if (this.instance && this.instance.set) {
                this.instance.set({ route: this.route });
            }
        },
        lang() {
            if (this.instance) this.instance.set({ lang: Vue.state.lang.currentLang });
        },
        async isLoggedIn() {
            if (this.watchIsLoggedIn) {
                await this.renewSession();
            }
        }
    },
    methods: {
        getRandom (length) {
            const alphabet = 'abcdefghijklmnopqrstuvwxyz0123456789';
            let result = ''
            while(result.length < length) {
                const rnd = Math.floor(Math.random() * alphabet.length)
                result += alphabet[rnd]
            }
            return result
        },
        async init() {
            await Vue.state.bk.session.open();
            const session = Vue.state.bk.session.get();

            const selector = `.bk-widget-${this.random}`;

            const settings = Object.assign({
                location: session.host,
                sid: session.sessionId,
                nums: session.nums,
                autoexpress: session.autoexpress,
                lottery: session.lottery,
                rmode: "abstract",
                rprefix: this.routePrefix,
                route: this.route,
                lang: Vue.state.lang.currentLang,
                outcomes: this.outcomes ? 1 : 0,
            }, this.settings);

            if (this.component) settings.component = this.component;
            
            if (this.hidenav) settings.hidenav = this.hidenav;
            if (this.client.view.bk.bkTheme) settings.theme = this.client.view.bk.bkTheme;
            if (this.theme) settings.theme = this.theme;
            
            console.log('bk-frame.init 1')
            this.instance = await bkWidget.initAsync(selector, settings);
            console.log('bk-frame.init 2')
            this.instance.addEventListener("showed", this.handleWidgetShowed);
            this.instance.addEventListener("hop", this.handleWidgetHop);
            this.instance.addEventListener("login", this.handleWidgetLogin);
            this.instance.addEventListener("orderDisplay", this.handleWidgetOrderDisplay);
            this.instance.addEventListener("orderEnabled", this.handleWidgetOrderEnabled);
            this.instance.addEventListener("ordered", this.handleWidgetOrdered);

            if (this.onInit) this.onInit();
        },
        async destroy() {
            this.destroying = true;
            if (this.onDestroying) this.onDestroying();

            await Vue.state.bk.session.close();

            console.log('bk-frame.destroy 1 ' + !!this.instance + ' instace=' + this.instance);
            if (this.instance) {
                this.instance.removeEventListener("ordered", this.handleWidgetOrdered);
                this.instance.removeEventListener("orderEnabled", this.handleWidgetOrderEnabled);
                this.instance.removeEventListener("orderDisplay", this.handleWidgetOrderDisplay);
                this.instance.removeEventListener("login", this.handleWidgetLogin);
                this.instance.removeEventListener("hop", this.handleWidgetHop);
                this.instance.removeEventListener("showed", this.handleWidgetShowed);
                this.instance.destroy();
                this.instance = null;
                console.log('bk-frame.destroy 2');
            }

            bkWidget.sweep();

            //let frame = document.querySelector(".bk-frame");
            //if (frame) frame.innerHTML = '<div class="bk-widget loading">loading...</div>';
            this.destroying = false;
        },
        handleWidgetShowed() {
            if (this.onShowed) this.onShowed();
        },
        handleWidgetHop(e) {
            const path = e.detail.route;
            if (this.$route.path === path) return;
            this.$router.push(path);
        },
        handleWidgetLogin() {
            this.$router.push({ name: "login" });
        },
        handleWidgetOrderDisplay(data) {
            if (this.onOrderDisplay) this.onOrderDisplay(data)
            EventBus.$emit("bk-frame/orderDisplay", data)
        },
        handleWidgetOrderEnabled(data) {
            if (this.onOrderEnabled) this.onOrderEnabled(data)
            EventBus.$emit("bk-frame/orderEnabled", data)
        },
        handleWidgetOrdered(data) {
            if (this.onOrdered) this.onOrdered(data);
        },
        async renewSession() {
            if (!this.destroying && this.instance) {
                await Vue.state.bk.session.close();
                await Vue.state.bk.session.open();
                const session = Vue.state.bk.session.get();
                const settings = {
                    sid: session.sessionId
                };
                if(this.instance)
                    this.instance.set(settings);
                else
                    await Vue.state.bk.session.close();
            }
        },
        handleBusSaveOrder() {
            this.instance.order()
        }
    },

    async mounted() {
        await Vue.state.client.ensure();
        await Vue.state.player.ensure();
        await this.init();
        this.watchIsLoggedIn = true;
        EventBus.$on("bk-frame/saveOrder", this.handleBusSaveOrder)
    },
    destroyed () {
        EventBus.$off("bk-frame/saveOrder", this.handleBusSaveOrder)
    },
    async beforeDestroy() {
        this.destroy();
    }
};
</script>
<style>
.bk-frame {
    align-self: stretch;
    flex: 1;
    display: flex;
    min-height: 77vh;
}

.bk-loading {
  display: flex;
  align-self: stretch;
  flex: 0 0 100%;
  justify-content: center;
  align-items: center;
}

.bk-loader {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: 50px;
}

.bk-loader__spinner {
    display: flex;
    justify-content: space-between;
    width: 70px;
    height: 10px;
    padding: 20px 0;
}

.bk-loader__dot {
    line-height: 5px;
    font-size: 25px;
    opacity: 0;
    animation: bk-loader__dot-blinking 1s infinite;
    animation-timing-function: ease-in-out;
}

.bk-loader__dot:nth-child(2) {
    animation-delay: .1s;
}

.bk-loader__dot:nth-child(3) {
    animation-delay: .2s;
}

.bk-loader__dot:nth-child(4) {
    animation-delay: .3s;
}

.bk-loader__dot:nth-child(5) {
    animation-delay: .4s;
}

.bk-loader__dot:nth-child(6) {
    animation-delay: .5s;
}

@keyframes bk-loader__dot-blinking {
  0% {}
  10% {opacity: 0}
  50% {opacity: 1}
  90% {opacity: 0}
  100% {}
}
</style>



// WEBPACK FOOTER //
// front/src/_common/components/bk-frame.vue